/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';

// assets
import { LuSend } from "react-icons/lu";
import DefaultProfile from '../../../assets/images/default_profile.jpeg';

// component
import EmotionLineChart from '../chart/patientDetail/EmotionLineChart';
import SurveyBarChart from '../chart/patientDetail/SurveyBarChart';

const PATIENT_TYPE = {
	EC: '탐색임상',
	CC: '확증임상',
	PR: '처방'
}

const PATIENT_GROUP = {
	EXP: '실험군',
	COMP: '대조군',
	TESTER: '테스터',
	COMMON: '일반'
}

const TRAINING = {
	'10': '시작 전',
	'20': '정상',
	'30': '종료',
	'40': '미달',
	'45': '탈락'
}

function MomtheraPatientDataSidebar({
	patientData,
	showModifyPatientModal,
	showSendMessageModal,
	emotionData,
	depressionData,
	anxietyData
}) {
	const [emotionLegend, setEmotionLegend] = useState([]);

	function createEmotionLegend() {
		const emotions = {};

		emotionData.forEach(session => {
			session.emotionInfoList.forEach(emotion => {
				// emotionCode를 기반으로 각 감정의 데이터를 수집
				if (!emotions[emotion.emotionCode]) {
					// 새로운 감정코드가 있으면 초기화
					emotions[emotion.emotionCode] = {
						code: emotion.emotionCode,
						name: emotion.emotionName,
						color: emotion.color
					};
				}
			});
		});
		const newEmotionLegend = Object.values(emotions);
		newEmotionLegend.sort((a,b)=>a.code-b.code);
		setEmotionLegend(newEmotionLegend);
	}

	useEffect(()=>{
		if(emotionData){
			createEmotionLegend();
		}		
	},[emotionData])

	return (
		<div className="patientManageDetail__patient">
			<div className='patient_detail_userInfo_wrapper'>
				<button className="patient_edit submitButton__rounded" onClick={showModifyPatientModal}>수정</button>
				<div className='patient_detail_userInfo_row'>
					<div className="patient_profile">
						<img
							src={patientData.avataImage || DefaultProfile}
							alt=""
							className="profileImage"
							style={{objectFit: 'contain'}}
						/>						
					</div>
					<div className="patient_detail">
						<div className="profileName">
							<span>
								{patientData.name ? patientData.name : '-'}
								{patientData.nickName ? `(${patientData.nickName})` : null}
								<button
									type='button'
									className='message_send_button'
									onClick={showSendMessageModal}
									aria-label='Message Send Button'
								>
									<LuSend />
								</button>
							</span>
						</div>				
						<div className="patient_detailItem">
							<span>
								{patientData.age ? `만 ${patientData.age}살` : null}
								{' '}
								{patientData.birth
									? `(${patientData.birth.slice(0,4)}-${patientData.birth.slice(4,6)}-${patientData.birth.slice(6,8)})`
									: '-'}
							</span>
						</div>
						<div className="patient_detailItem">
							<span>
								{patientData.phoneNumber
									? `${patientData.phoneNumber.substring(0, 3)}-${patientData.phoneNumber.substring(
											3,
											patientData.phoneNumber.length - 4,
									)}-${patientData.phoneNumber.substring(
											patientData.phoneNumber.length - 4,
											patientData.phoneNumber.length,
									)}`
									: '-'}
							</span>
						</div>
					</div>
				</div>
				<div className='patient_detail_userInfo_row' style={{gap: '20%'}}>
					<div className="patient_detail">
						<div className="patient_detail__title">사용자 상태</div>
						<div className="patient_detailItem">
							<span>
								{patientData.patientType ? PATIENT_TYPE[patientData.patientType] : null}
								{patientData.patientGroup ? `(${PATIENT_GROUP[patientData.patientGroup]})` : null}
							</span>
						</div>
						<div className="patient_detailItem">
							<span>
								{patientData.pregnantStatusCode==='01' && '임신'}
								{patientData.pregnantStatusCode==='02' && '출산'}
							</span>
						</div>
					</div>
					<div className="patient_detail">
						<div className="patient_detail__title">어플 사용 정보</div>
						<div className="patient_detailItem">
							<span>진행중 교육</span>
							<span>{patientData.studySession ? `${patientData.studySession}` : '0'}주차</span>
						</div>
						<div className="patient_detailItem">
							<span>진도율</span>
							<span>{patientData.training ? `${TRAINING[patientData.training]}` : null}</span>
						</div>
					</div>
				</div>
			</div>
			<div className="patient_detail" style={{width: '30%'}}>
				<div className="patient_detail__title">기분 상태 점검</div>
				<div className="momthera_emotion_graph_legend">
					{emotionLegend.map(emotion=>(
						<div key={emotion.name} className="momthera_emotion_legend_item">
							<div className='legend_icon' style={{backgroundColor: emotion.color}} />
							<span>{emotion.name}</span>
						</div>
					))}
				</div>
				<div className='momthera_patient_detail_graph_box'>
					<EmotionLineChart emotionData={emotionData} />
				</div>
			</div>
			<div className="patient_detail" style={{width: '30%'}}>
				<div className="patient_detail__title">우울 및 불안 점수</div>
				<div className="momthera_emotion_graph_legend">
					{depressionData.length>0 && <div className="momthera_emotion_legend_item">
						<div className='legend_icon' style={{backgroundColor: '#76ABFF'}} />
						<span>우울</span>
					</div>}
					{anxietyData.length>0 && <div className="momthera_emotion_legend_item">
						<div className='legend_icon' style={{backgroundColor: '#FF8567'}} />
						<span>불안</span>
					</div>}
				</div>
				<div className='momthera_patient_detail_graph_box'>
					<SurveyBarChart firstData={depressionData} secondData={anxietyData} />
				</div>
			</div>
		</div>
	);
}

export default MomtheraPatientDataSidebar;
